module.exports = __webpack_public_path__ + "img/logo.0c825db6.png";